<div (click)="emitSortEvent()" class="sort-wrapper cursor-pointer">
  <div class="sort-arrows">
    <app-st-icon [color]="sortDirection === 'asc' ? '#0072F5' : undefined"
                 class="no-select" [filled]="true" name="arrow_drop_up"></app-st-icon>
    <app-st-icon [color]="sortDirection === 'desc' ? '#0072F5' : undefined"
                 class="no-select" [filled]="true" name="arrow_drop_down"></app-st-icon>
  </div>
</div>
